module.exports = __webpack_public_path__ + "assets/img/moveTitleIcon.494a5116.svg";